export enum SmallWallType {
    None = 0, // Geen
    DampProof = 1, // Trasraam
    Concrete = 2, // Beton
    ConcreteIsolated = 3 // Beton geisoleerd
};